import { Application } from '@hotwired/stimulus';
import SearchController from './search_controller';
import HeartsController from './hearts_controller';

const application = Application.start();

application.register('search', SearchController);
application.register('hearts', HeartsController);

// Expose for debugging in development.
window.Stimulus = application;

export default application;
